import * as React from 'react';

import {
	Wrapper,
	LabelWrapper,
	ProgressLabel,
	Label,
	ButtonCancel,
	Bar,
} from './styles';
import { FileError } from '../../../containers/ImportManager/actions';
import Utils from '../../../utils';

interface ProgressBarProps {
	percentage: number;
	error: FileError | null;
	isProcessing?: boolean;
	processingLabel?: string;
	hasCancelButton?: boolean;
	onCancel?: () => void;
}

const getLabel = (percentage: number, error: FileError | null, isProcessing?: boolean, processingLabel?: string) => {
	if (error) {
		return <Label value={`error.${error}`} isError={true} />;
	} else if (isProcessing) {
		return processingLabel && <Label value={processingLabel} />;
	}
	return <ProgressLabel>{percentage}%</ProgressLabel>;
};

const ProgressBar = ({
	percentage,
	error,
	isProcessing,
	processingLabel,
	hasCancelButton,
	onCancel,
}: ProgressBarProps) => (
	<Wrapper>
		<LabelWrapper>
			{getLabel(percentage, error, isProcessing, processingLabel)}
			{hasCancelButton && !isProcessing &&
				<ButtonCancel
					type="button"
					isError={!!error}
					onClick={onCancel}
				>
					{Utils.getSvgIcon('iconset_close-2')}
				</ButtonCancel>
			}
		</LabelWrapper>
		<Bar
			isError={!!error}
			percentage={percentage}
		/>
	</Wrapper>
);

export default ProgressBar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ResourceSelector/ProgressBar/index.tsx